/**
 * Smooth scroll to element or hash
 */
export function smoothScrollTo(target: string | HTMLElement) {
	if (typeof document === 'undefined') return;
	
	const element = typeof target === 'string' 
		? document.querySelector(target) || document.getElementById(target.replace('#', ''))
		: target;
	
	if (!element) return;
	
	element.scrollIntoView({
		behavior: 'smooth',
		block: 'start'
	});
}

/**
 * Handle anchor link clicks for smooth scrolling
 */
export function handleAnchorClick(event: MouseEvent) {
	if (typeof window === 'undefined') return;
	
	const target = event.currentTarget as HTMLAnchorElement;
	const href = target.getAttribute('href');
	
	if (href && href.startsWith('#')) {
		event.preventDefault();
		smoothScrollTo(href);
		
		// Update URL without triggering navigation
		if (typeof history !== 'undefined') {
			history.pushState(null, '', href);
		}
	}
}

/**
 * Initialize smooth scrolling for all anchor links
 */
export function initSmoothScroll() {
	if (typeof window === 'undefined') return;
	
	// Handle all anchor links with hash
	document.addEventListener('click', (event) => {
		const target = event.target as HTMLElement;
		const anchor = target.closest('a[href^="#"]');
		
		if (anchor) {
			handleAnchorClick(event as MouseEvent);
		}
	});
	
	// Handle initial hash on page load
	if (window.location.hash) {
		setTimeout(() => {
			smoothScrollTo(window.location.hash);
		}, 100);
	}
}